import { useState } from 'react'
import styles from './styles.module.scss'
import { InstitutionRepository } from '../../../../repositories/institution.repository'
import { TypeState } from '..'
import { useAuth } from '../../../../../../hooks/useAuth'
import { useParams } from 'react-router-dom'
import { Loader } from '@/components/Loader'
import { Course, ICourseCreate } from '@/domain/entities/course.entity'
import { courseStore } from '@/stores/course.store'

interface IProps {
  setState: React.Dispatch<React.SetStateAction<TypeState>>
  courses: Course[]
}

export const AddCourse = ({ setState, courses }: IProps) => {
  const { token } = useAuth()
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [course, setCourse] = useState({
    category_id: 2,
    modality: 'PRESENCIAL',
    shift: 'MANHA',
  } as ICourseCreate)

  const { setCourses } = courseStore()

  async function addCourse() {
    let hasNull = false
    Object.keys(course).forEach((i) => {
      if (!course[i] && i != 'description') hasNull = true
    })

    if (hasNull) return
    setLoading(true)

    const novoCurso = await InstitutionRepository.GetInstance().addCourse({
      token,
      data: { ...course, institution_id: +id },
    })
    setCourses([novoCurso, ...courses])
    setState('CURSOS')
    setLoading(false)
  }

  return (
    <div className={styles.form_container}>
      {loading && <Loader />}
      <select
        onChange={(e) =>
          setCourse({ ...course, category_id: Number(e.target.value) })
        }
      >
        <option value={'2'}>Ensino Básico</option>
        <option value={'3'}>Técnico</option>
        <option value={'4'}>Profissionalizante</option>
        <option value={'5'}>EJA</option>
        <option value={'6'}>Idiomas</option>
        <option value={'7'}>Pré-Vestibular / Preparatório</option>
        <option value={'8'}>Infantil</option>
        <option value={'9'}>Período Integral</option>
      </select>
      <select
        onChange={(e) => setCourse({ ...course, modality: e.target.value })}
      >
        <option value={'PRESENCIAL'}>PRESENCIAL</option>
        <option value={'EAD'}>EAD</option>
      </select>
      <select onChange={(e) => setCourse({ ...course, shift: e.target.value })}>
        <option value={'MANHA'}>MANHA</option>
        <option value={'TARDE'}>TARDE</option>
        <option value={'NOITE'}>NOITE</option>
      </select>
      <input
        onChange={(e) => setCourse({ ...course, name: e.target.value })}
        placeholder="titulo"
        value={course?.name}
      />
      <input
        onChange={(e) =>
          setCourse({ ...course, scholarship_year: Number(e.target.value) })
        }
        placeholder="ano bolsa"
        value={course?.scholarship_year}
      />
      <input
        onChange={(e) =>
          setCourse({ ...course, vacancies: Number(e.target.value) })
        }
        placeholder="vagas"
        value={course?.vacancies}
      />
      <input
        onChange={(e) => setCourse({ ...course, description: e.target.value })}
        placeholder="descrição"
        value={course?.description}
      />
      <input
        onChange={(e) => setCourse({ ...course, amount: e.target.value })}
        placeholder="valor"
        value={course?.amount}
      />
      <input
        onChange={(e) =>
          setCourse({ ...course, promotional_value: e.target.value })
        }
        placeholder="Valor promocional"
        value={course?.promotional_value}
      />
      <input
        onChange={(e) => setCourse({ ...course, percent: e.target.value })}
        placeholder="percentual"
        value={course?.percent}
      />
      <button onClick={addCourse}>Adicionar Curso</button>
    </div>
  )
}
